import React, { useState } from "react";
import { ListTable } from "../Table/listTable/listTable";
import { sentNotificaionListTitle } from "../../Constants/tableTitles/ListTableTitle/SentNotificationLists.titles";
import { transformSentNotificationListTableData } from "../../Services/transformer/transformSentNotificationListsTableData";
import { useGetSentNotificationLists } from "../../hooks/notifications/notifications.hooks";

export const SentNotificationsLists = () => {
  const [pageToSearch, setPageToSearch] = useState(1);

  const { isLoading, data: sentNotificationLists } =
    useGetSentNotificationLists({
      page: pageToSearch,
    });

  return (
    <ListTable
      titles={sentNotificaionListTitle}
      data={sentNotificationLists?.result}
      isDataLoading={isLoading}
      transformFn={transformSentNotificationListTableData}
      pagination={{
        totalPage: sentNotificationLists?.lastPage,
        onPageChange: (pageNo) => {
          setPageToSearch(pageNo);
        },
      }}
    />
  );
};
